"use client";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import { ThemeContext, useTheme } from ".";
import { Overrides, Theme, ThemeName, vars } from "./theme.css";

export const ThemeProvider = ({
  children,
  theme,
  overrides,
}: {
  children: React.ReactNode;
  theme?: ThemeName;
  overrides?: Overrides;
}) => {
  const { setTheme } = useTheme();

  if (theme) {
    return (
      <ThemeContext.Provider
        value={{
          theme,
          setTheme,
        }}
      >
        <div
          className={theme}
          style={assignInlineVars(vars, overrides as Theme)}
        >
          {children}
        </div>
      </ThemeContext.Provider>
    );
  } else if (overrides) {
    return (
      <div style={assignInlineVars(vars, overrides as Theme)}>{children}</div>
    );
  } else {
    return <>{children}</>;
  }
};
